var map = {
	"./AXE-Logo-1.png": 3576,
	"./Burger_King-Logo.wine.svg": 2438,
	"./Capitec colour.png": 9563,
	"./Diageo.png": 3447,
	"./Doritos.png": 918,
	"./DreamWorks.png": 3523,
	"./Himalaya Wellness.png": 3593,
	"./Intuition.png": 4455,
	"./Listerine.png.png": 3554,
	"./Marmite.png": 6699,
	"./NikNaks.png": 9687,
	"./Old Khaki.svg": 2897,
	"./Pasta Grande.jpeg": 6631,
	"./Pepsico_blue.png": 4658,
	"./Rhodes.png": 9633,
	"./Shoprite-logo.png": 9898,
	"./Simba.png": 8438,
	"./Smirnoff.png": 9058,
	"./Strongbow.png": 2231,
	"./Tigers Milk Black.png": 88,
	"./Unilever.png": 3636,
	"./VIU.png": 2864,
	"./Weet-Bix.png": 5619,
	"./Wellingtons.png": 4562,
	"./Woolworths-Logo.png": 8504,
	"./cape-union-mart-vector-logo.svg": 1404,
	"./debonairs_pizza.png": 8434,
	"./icon-simba-munchiez.png": 5800,
	"./inDrive logo.png": 4146,
	"./jhonnie-walker-logo.png": 7938,
	"./la-parada-logo-black.png": 8431,
	"./liquifruit-logo.png": 6934,
	"./tresemme.svg": 2110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7569;